export class ObjectUtils {
    static removeNullUndefinedFields(obj: Record<string, any>): Record<string, any> {
        const newObj: Record<string, any> = {};

        for (const [key, value] of Object.entries(obj)) {
            if (value !== null && value !== undefined) {
                if (Array.isArray(value)) {
                    newObj[key] = value.map((item) => {
                        if (typeof item === "object" && !Array.isArray(item)) {
                            return ObjectUtils.removeNullUndefinedFields(item);
                        }
                        return item;
                    });
                } else if (value instanceof Date) {
                    newObj[key] = value.toISOString();
                } else if (typeof value === "object" && !Array.isArray(value)) {
                    newObj[key] = ObjectUtils.removeNullUndefinedFields(value);
                } else {
                    newObj[key] = value;
                }
            }
        }

        return newObj;
    }
}
